
<div class="app-header-left">
  <app-search-box (click)="hideMegamenu()"></app-search-box>
</div>

